<template>
	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link id="buttonback"
									 :to="{ name: 'bannersList'}">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку банеров
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника баннеры:</h3>
							<div v-if="banner && rooms" class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep">
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('order')">
										<label>{{mapElementName['order']}}</label>
										<md-input v-if="action === 'delete'" readonly v-model.number="form['order']"
												  type="text"></md-input>
										<md-input v-else v-model="form['order']" type="text"></md-input>
									</md-field>
								</div>
								<h5>Тип помещения:</h5>
								<template v-for="room in rooms">
									<md-radio v-model="form.roomType"
											  :key="room.id"
											  :value="room.id"
									>{{ room.roomName }}</md-radio><br/>
								</template>
								<h5>Фото:</h5>
								<img :src="itemPhoto" v-if="itemPhoto">
								<div style="margin-top: 10px;">
									<label>Выбрать фото
										<input id="photo" ref="photo" type="file"
											   v-on:change="handleFileUpload('photo')"/>
									</label>
								</div>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="banner">
									<md-button v-if="action !== 'delete'"
											   @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default">
										Сохранить
									</md-button>

									<md-button v-if="action === 'delete'"
											   @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default">
										Удалить
									</md-button>

								</template>
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>
		<md-dialog-alert
				:md-active.sync="alert"
				:md-content="alertText"
				md-confirm-text="OK" />
	</div>
</template>
<script>
    import {validationMixin} from 'vuelidate';
    import {checkAuthentication, reAuthenticate} from '@/utils/auth-api';
    import {
        required,
    } from 'vuelidate/lib/validators';
    import { getRooms } from '@/utils/room-api'
    import { getBanners, updateBanner, removeBanner } from '@/utils/banners-api'
    import { uploadFile, getFile } from '@/utils/dict-api'

    export default {
        mixins: [
            validationMixin,
        ],
        bodyClass: 'dictionary-data',
        props: ['action'],
        data() {
            return {
                alert: false,
                alertText: '',
                banner: false,
                rooms: false,
                photo: false,
                mapElementName: {
                    roomType: 'Тип помещения',
                    photoId: 'Фото',
                    order: 'Сортировка',
                },
                form: {
                    action: 'save',
                    roomType: '',
                    photoId: '',
                    order: '',
                },
            };
        },
        validations: {
            form: {
                roomType: {
                    required,
                },
                photoId: {
                    required,
                },
            },
        },
        computed: {
            itemPhoto: function () {
                if (this.banner.photoId)
                    return getFile(this.banner.photoId)
            },
        },
        methods: {
            getValidationClass(fieldName) {
                const field = this.$v.form[fieldName];
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    };
                }
            },
            validateData(sendFn) {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {
                    sendFn();
                } else {
                    this.alertText = "Не все данные заполнены"
                    this.alert = true
				}
            },
            setData: function (data) {
                this.form = data;
            },
            getElementData: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    getRooms().then(result => {
                        this.rooms = result
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                    if (this.$route.params.id === 'new') {
                        this.addItem();
                        return;
                    }

                    getBanners().then(result => {
                        this.banner = result.find(item => +item.id === +this.$route.params.id)
                        this.setData(this.banner)
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            addItem: function () {
                const item = {
                    id: 'new',
                    roomType: '',
                    photoId: '',
                    order: '',
                };
                this.setData(item);
                this.banner = item
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null;
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    updateBanner(JSON.stringify(this.form)).then(result => {
                        this.$router.push({name: 'bannersList'});
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
                });
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    removeBanner(JSON.stringify({id: this.$route.params.id})).then(result => {
                        this.$router.push({name: 'bannersList'});
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
                });
            },
            handleFileUpload (name) {
                this[name] = this.$refs[name].files[0]
				this.submitFile(name)
            },
            submitFile (name) {
                let formData = new FormData()
                formData.append('file', this[name])
                uploadFile(formData).then(response => {
                    this.banner.photoId = response.id
                    this.form.photoId = response.id
                })
            },
        },
        created() {
            if (this.$route.params.action === 'delete') {
                this.deleteItem();
            } else {
                this.getElementData();
            }
        },
    };
</script>

<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>
